import { Api } from 'container-data-segment-compare'
import { microServiceOrigin } from 'src/api/path'
import { appRootPath } from 'src/_funcSwitch'
import { tokenService } from 'src/helpers/tokenService'

const api = new Api(
  { 
    baseUrl: microServiceOrigin,
    before (conf) {
      api.token = tokenService.get() || ''
      return conf
    }
  },
)

export const segmentCompareProps = {
  api,
  rootPath: appRootPath + '/configCenter/segmentCompare',
  access: {
    insight: true,
    delete: true,
    sameTypeCompare: true,
    sortTypeChange: true,
  }
} as any
